import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

// @vue/component
export default {
  name: "AntragstellerModalVacateAstAdmin",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    antragsteller: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
    };
  },
  methods: {
    onSave() {
      this.status.loading = true;
      this.postHttp({ url: `antragstellerorganisationen/${ this.antragsteller.pk }/vacate_astadmin/` }).then(
        () => {
          this.addNotification({ text: "_MSG_ANTRAGSTELLER_TABLE_MODAL_VACATE_ASTADMIN_SUCCESS_" });
          this.close({ status: true });
        },
        () => {
          this.addNotification({ text: "_MSG_ANTRAGSTELLER_TABLE_MODAL_VACATE_ASTADMIN_ERROR_", type: "error" });
          this.close();
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
